import { Component, OnInit } from '@angular/core';
import { BaseComponent, ErrorsUtil, MessageBoxComponent, WaitComponent } from '@sircon/sircon-ui-framework';
import { WorkflowProvider } from 'src/providers/workflow.service';
import { LoginHttpService } from 'src/providers/login-http.service';
import { catchError, finalize, takeUntil, tap, throwError } from 'rxjs';
import { EnvService } from 'src/services/env.service';
import { NgIf } from '@angular/common';
import { SignInHelpOptionsComponent } from './sign-in-help-options/sign-in-help-options.component';
import { LostAccountIdComponent } from './lost-account-id/lost-account-id.component';
import {
    LostAccountIdConfirmationComponent
} from './lost-account-id-confirmation/lost-account-id-confirmation.component';

@Component({
    selector: 'app-sign-in-help-workflow',
    templateUrl: './sign-in-help-workflow.component.html',
    styleUrls: ['./sign-in-help-workflow.component.less'],
    imports: [NgIf, WaitComponent, MessageBoxComponent, SignInHelpOptionsComponent, LostAccountIdComponent,
        LostAccountIdConfirmationComponent]
})
export class SignInHelpWorkflowComponent extends BaseComponent implements OnInit {
    submitting = false;
    resend = false;
    resentSuccess = false;
    doneLoading = false;
    errors = ErrorsUtil.create();
    emailAddress = '';

    readonly steps = [
        { title: 'Help Options' },
        { title: 'Account ID Recover' },
        { title: 'Account ID Confirmation' }
    ];
    readonly HELP_OPTIONS_STEP = 0;
    readonly ACCOUNT_ID_RECOVERY_STEP = 1;
    readonly ACCOUNT_ID_CONFIRMATION_STEP = 2;
    readonly HELP_TITLE = 'Help Signing In';
    readonly LOST_ACCOUNT_ID_TITLE = 'Lost Account ID';
    readonly getCurrentStep: () => number;
    readonly getName: () => string;
    readonly doneLoadingWorkflow: () => boolean;

    constructor(protected workflowProvider: WorkflowProvider,
                private loginHttpService: LoginHttpService,
                private env: EnvService) {
        super();
        this.getCurrentStep = this.workflowProvider.getCurrentStep.bind(this.workflowProvider);
        this.getName = this.workflowProvider.getName.bind(this.workflowProvider);
        this.doneLoadingWorkflow = this.workflowProvider.getDoneLoadingWorkflow.bind(this.workflowProvider);
    }

    ngOnInit(): void {
        this.workflowProvider.reset();
        this.workflowProvider.setSteps(this.steps);
        this.workflowProvider.setName(this.HELP_TITLE);
        this.workflowProvider.goToStep(this.HELP_OPTIONS_STEP);
        this.doneLoading = true;
    }

    getWorkflowStep() {
        return this.workflowProvider.getCurrentStep();
    }

    goToHelpOptions() {
        this.workflowProvider.goToStep(this.HELP_OPTIONS_STEP);
        this.workflowProvider.setName(this.HELP_TITLE);
    }

    goToResetPassword() {
        window.open(this.env.SIRCON_URL + '/ComplianceExpress/login/forgotYourPassword.jsp', '_self');
    }

    goToRecoverAccountId() {
        this.resentSuccess = false;
        this.workflowProvider.goToStep(this.ACCOUNT_ID_RECOVERY_STEP);
        this.workflowProvider.setName(this.LOST_ACCOUNT_ID_TITLE);
    }

    getEmailAddressForAccountIdRecovery(workflowEvent) {
        this.emailAddress = workflowEvent.emailAddress;
        this.sendEmail();
    }

    resendEmail() {
        this.resend = true;
        this.sendEmail();
    }

    sendEmail() {
        if (this.emailAddress) {
            ErrorsUtil.clear(this.errors);
            this.submitting = true;
            if (this.resend) {
                this.resentSuccess = false;
            }
            this.loginHttpService.initiateRecoverAccountInformationEvent(this.emailAddress).pipe(
                tap(() => {
                    this.workflowProvider.goToStep(this.ACCOUNT_ID_CONFIRMATION_STEP);
                    if (this.resend) {
                        this.resentSuccess = true;
                    }
                }),
                catchError((response) => {
                    this.errors = ErrorsUtil.mapResponse(response);
                    return throwError(() => response.message);
                }),
                finalize(() => {
                    this.submitting = false;
                    this.resend = false;
                }),
                takeUntil(this.ngUnsubscribe)
            ).subscribe();
        }
    }
}
